import { render } from "./LastMonthsChart.vue?vue&type=template&id=2be51262&ts=true"
import script from "./LastMonthsChart.vue?vue&type=script&lang=ts"
export * from "./LastMonthsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__